package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import coil3.compose.AsyncImage
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import androidx.compose.ui.tooling.preview.Preview

/**
 * Circular avatar for a person or business: remote [photoUrl] when available, otherwise the first
 * letter of [name] on a soft category-chip field (the app-wide initial-avatar pattern), otherwise
 * a [fallbackIconName] glyph. While a photo loads (or if it errors) the initial/icon stays visible
 * underneath, so the row never shows an empty circle.
 */
@Composable
fun AppAvatar(
    name: String?,
    modifier: Modifier = Modifier,
    photoUrl: String? = null,
    size: Dp = AppTheme.sizes.avatarMd,
    contentDescription: String? = null,
    fallbackIconName: String = "person",
) {
    Box(
        modifier = modifier
            .size(size)
            .clip(AppTheme.shapes.pill)
            .background(AppTheme.colors.categoryChip),
        contentAlignment = Alignment.Center,
    ) {
        val initial = name?.trim()?.firstOrNull()
        if (initial != null) {
            Text(
                text = initial.uppercase(),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.primary,
            )
        } else {
            AppIcon(
                name = fallbackIconName,
                size = AppTheme.sizes.iconMd,
                tint = AppTheme.colors.primary,
            )
        }
        if (!photoUrl.isNullOrBlank()) {
            AsyncImage(
                model = photoUrl,
                contentDescription = contentDescription,
                contentScale = ContentScale.Crop,
                modifier = Modifier.fillMaxSize(),
            )
        }
    }
}

@Preview
@Composable
private fun AppAvatarPreview() {
    AppTheme {
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            AppAvatar(name = "Sara")
            AppAvatar(name = null)
            AppAvatar(name = "Golestan Bakery", size = AppTheme.sizes.avatarSm)
        }
    }
}
